export default __webpack_public_path__ + "static/media/img1.952964a1.png";